export default class LocationsMapController {
    constructor() {
        this.listContainer = null;
        this.mapContainer = null;

        this.apiKey = null;
        this.map = null;
        this.maps = null;

        if (document.querySelector('.locationsListContainer')) {
            this.listContainer = document.querySelector('.locationsListContainer');
        }

        if (document.querySelector('.locationsMapContainer')) {
            this.mapContainer = document.querySelector('.locationsMapContainer');
        }

        if (this.listContainer) {
            this.init();
        }
    }

    init() {
        if (this.mapContainer) {
            if (this.mapContainer.dataset.key) {
                this.apiKey = this.mapContainer.dataset.key;
                this.initMap();
            } else {
                console.error('Missing Google Maps API key');
            }
        }

        this.setEventListeners();
    }

    initMap() {
        // Create script
        const script = document.createElement('script');
        script.setAttribute('src', `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&callback=app.locationsMapController.mapsApiLoaded`);
        document.body.appendChild(script);
    }

    mapsApiLoaded() {
        // Called by the Maps API once it's loaded
        this.maps = window.google.maps;
        this.map = new this.maps.Map(this.mapContainer.querySelector('.map'), {
            center: { // Sort of center of NL
                lat: 52.1927064,
                lng: 5.6074137
            },
            draggable: false,
            disableDefaultUI: true, // No interaction needed
        });

        this.createMapMarkers();
    }

    createMapMarkers() {
        // At this point, we have the locations and map loaded
        const bounds = new this.maps.LatLngBounds();
        this.markers = [];

        const listItems = this.listContainer.querySelectorAll('ul.locations > li[data-lat][data-lon]'); // Only get items that have a lot an lon set
        listItems.forEach(listItem => {
            const lat = parseFloat(listItem.dataset.lat);
            const lon = parseFloat(listItem.dataset.lon);

            const marker = new this.maps.Marker({
                map: this.map,
                position: {
                    lat: lat,
                    lng: lon,
                },
                icon: listItem.classList.contains('active') ? '/img/marker_highlight.svg' : '/img/marker.svg',
                title: listItem.querySelector('h2')?.innerHTML ?? 'Locatie',
            });

            this.markers.push(marker);

            bounds.extend(marker.position);

            marker.addListener('click', e => {
                this.setActive(listItem);
            });

            listItem.addEventListener('active', () => {
                this.markers.forEach(marker => {
                    marker.setIcon('/img/marker.svg');
                });

                marker.setIcon('/img/marker_highlight.svg');
            });
        });

        this.map.fitBounds(bounds);

        app.registerResizeEvent(() => {
            if (window.innerWidth >= app.breakpoints.md.size) {
                this.map.fitBounds(bounds);
            }
        });

        // Fit bounds again to be sure that it's focussed
        setTimeout(() => {
            this.map.fitBounds(bounds);
        }, 200);
    }

    setEventListeners() {
        this.listContainer.querySelectorAll('ul.locations > li').forEach(location => {
            location.querySelector('button').addEventListener('click', this.setActive.bind(this, location));
        });
    }

    setActive(listItem) {
        let scrollPosition = document.documentElement.scrollTop;
        this.clearActive();
        listItem.classList.add('active');
        listItem.setAttribute('aria-expanded', 'true');
        listItem.dispatchEvent(new CustomEvent('active'));

        document.documentElement.scrollTop = scrollPosition;
    }

    clearActive() {
        this.listContainer.querySelectorAll('ul.locations > li').forEach(listItem => {
            listItem.classList.remove('active');
            listItem.setAttribute('aria-expanded', 'false');
        });

        if (this.mapContainer) {

        }
    }
}